// extracted by mini-css-extract-plugin
export default {"root":"styles_root__nebGF","dishList":"styles_dishList__sip6T","dish":"styles_dish__1SBCw"};